<template>
  <span v-if="owners.length">
    <el-button size="small" @click="visible=true">批量转交</el-button>
    <el-dialog title="按负责人批量转交" :visible.sync="visible" width="520px" append-to-body>
      <el-alert title="转交未关闭线索、客户及进行中商机，并同步这些记录的未完成提醒。公海与已归档记录不转交，操作会留下记录。" type="info" :closable="false" />
      <el-form label-width="100px" style="margin-top:20px">
        <el-form-item label="原负责人"><el-select v-model="from" filterable style="width:100%"><el-option v-for="user in owners" :key="user.id" :value="user.id" :label="label(user)" /></el-select></el-form-item>
        <el-form-item label="接手人员"><el-select v-model="to" filterable style="width:100%"><el-option v-for="user in activeOwners" :key="user.id" :value="user.id" :label="label(user)" :disabled="user.id === from" /></el-select></el-form-item>
      </el-form>
      <div slot="footer"><el-button @click="visible=false">取消</el-button><el-button type="primary" :loading="saving" @click="transfer">确认转交</el-button></div>
    </el-dialog>
  </span>
</template>
<script>
import { crm } from '../api/crm'
export default {
  name: 'CrmOwnerTransfer',
  data() { return { owners: [], visible: false, from: null, to: null, saving: false } },
  computed: { activeOwners() { return this.owners.filter(u => Number(u.enabled) !== 0) } },
  async created() { const res = await crm.transferOwners(); this.owners = res.data || [] },
  methods: {
    label(user) { return (user.nickname || user.username) + (Number(user.enabled) === 0 ? '（已停用）' : '') },
    async transfer() {
      if (!this.from || !this.to || this.from === this.to) return this.$message.warning('请选择不同的原负责人和接手人员')
      try { await this.$confirm('将转交原负责人当前范围内的全部符合条件资源，是否确认？', '确认转交', { type: 'warning' }) } catch (_) { return }
      this.saving = true
      try {
        const res = await crm.transfer({ fromOwnerId: this.from, toOwnerId: this.to })
        const data = res.data || {}
        this.$message.success(`已转交线索 ${data.LEAD || 0} 条、客户 ${data.CUSTOMER || 0} 条、商机 ${data.DEAL || 0} 条`)
        this.visible = false
        this.$emit('changed')
      } finally { this.saving = false }
    }
  }
}
</script>
